import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { InputTextModule } from 'primeng/inputtext'

import { GlobalSearchComponent } from './global-search'
import { GlobalSearchService } from './global-search.service'

@NgModule({
  imports: [
    FormsModule,
    InputTextModule,
    RouterModule,
    GlobalSearchComponent,
  ],
  exports: [
    GlobalSearchComponent,
  ],
  providers: [
    GlobalSearchService,
  ],
})
export class GlobalSearchModule {}
